// extracted by mini-css-extract-plugin
export default {"row":"FeatureRow_row__Tf5Nz","actions":"FeatureRow_actions__cahOt","limitedText":"FeatureRow_limitedText__7aUjz","criteriaType":"FeatureRow_criteriaType__esbJS"};